import React, {FC} from 'react'
import {useSelector} from 'react-redux'
import {Link} from 'react-router-dom'
import {selectPagingCurrentPage} from 'app/redux/pagingSlice'
import {RootState} from 'setup'

interface Props {
  id: string
  children: React.ReactNode
  to: string
  state?: any
  className?: string
}

const LinkState: FC<Props> = ({
  children,
  to,
  state,
  id,
  className = 'btn btn-icon btn-sm btn-outline btn-outline-secondary btn-active-text-white me-2',
}) => {
  const currentPage = useSelector<RootState, number>(selectPagingCurrentPage)

  const handleSetSession = () => {
    setStateSession({
      filter: {
        ...state,
        currentPage: state && state.currentPage ? state.currentPage : currentPage,
      },
    })
  }
  return (
    <Link id={id} to={to} state={state} onClick={handleSetSession} className={className}>
      {children}
    </Link>
  )
}

export default LinkState

export const setStateSession = (state: any) => {
  const filter = {...state, route: window.location.pathname}
  sessionStorage.setItem('current_state', JSON.stringify(filter))
}
